<ng-container *transloco="let t; read: 'configuration-table'">
  <table
    mat-table
    [dataSource]="tableDataSource()"
    matSort
    [matSortActive]="sortBy()"
    [matSortDirection]="sortDirection()"
    matSortDisableClear
    (matSortChange)="sort.set($event)"
    class="configuration-list__config-table"
  >
    <ng-container matColumnDef="lang">
      <th
        class="configuration-list__config-table-header-lang"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
      >
        <div class="configuration-list__table-header-content">
          <div class="configuration-list__table-header-border"></div>
          <span>{{ t('lang') }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let config" class="configuration-list__table-cell">
        {{ config.language_id | uppercase }}
      </td>
    </ng-container>

    <ng-container matColumnDef="configName">
      <th
        class="configuration-list__config-table-header-name"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
      >
        <div class="configuration-list__table-header-content">
          <div class="configuration-list__table-header-border"></div>
          <span>{{ t('name') }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let config" class="configuration-list__table-cell">
        <div class="configuration-list__config-table-name-column">
          <ng-container *appMiddleEllipsize="config.name"></ng-container>
          @if (config.layer) {
            <xi-icon icon="multiple_layer"></xi-icon>
          }
          @if (config.removed) {
            <app-lex-tag-button type="small" matIcon="delete">
              {{ t('deleted') }}
            </app-lex-tag-button>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="tags">
      <th class="configuration-list__config-table-header-tags" mat-header-cell *matHeaderCellDef>
        <div class="configuration-list__table-header-content">
          <div class="configuration-list__table-header-border"></div>
          <span>{{ t('tags') }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let config">
        <app-tag-autowrap [configuration]="config"></app-tag-autowrap>
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th
        class="configuration-list__config-table-header-createdBy"
        mat-header-cell
        *matHeaderCellDef
      >
        <div class="configuration-list__table-header-content">
          <div class="configuration-list__table-header-border"></div>
          <span>{{ t('created-by') }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let config" class="configuration-list__table-cell">
        {{ getCreator(config) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastUsed">
      <th
        class="configuration-list__config-table-header-lastUsed"
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
      >
        <div class="configuration-list__table-header-content">
          <div class="configuration-list__table-header-border"></div>
          <span>{{ t('last-used') }}</span>
        </div>
      </th>
      <td mat-cell *matCellDef="let config" class="configuration-list__table-cell">
        {{ config.last_processing_date | lexDate: 'short' }}
      </td>
    </ng-container>

    <tr
      class="configuration-list__config-table-header-row"
      mat-header-row
      *matHeaderRowDef="displayedColumns(); sticky: true"
    ></tr>
    <tr
      (click)="onConfigurationSelected(row)"
      [ngClass]="{ 'configuration-list__config--removed': row.removed }"
      mat-row
      *matRowDef="let row; columns: displayedColumns()"
    ></tr>
  </table>
</ng-container>
